import { Trans, useTranslation } from 'react-i18next'

import { InsertColumnPosition } from '@makyoapp/makyo-sdk/api/Tables'

import { CreateColumnProvider } from '@/context/CreateColumnContext'

import { useGridV2Context } from '../../contexts/GridV2Context'
import { ColumnForm } from '../form/ColumnForm'
import { GridModalWrap } from './GridModalWrap'

/**
 * Modal used to insert column
 * field is the same as AddColumnButton modal
 * but use a modal instead of flyover dropdown
 * because no way to get toggle position
 */
export function GridInsertColumn() {
  const { t } = useTranslation()
  const { columnToInsert, setAddColumnModalOpen, handleCloseMenu } = useGridV2Context()
  const title =
    columnToInsert?.positionToInsert === InsertColumnPosition.Left ? t('Insert Column Left') : t('Insert Column Right')

  const handleClose = () => {
    setAddColumnModalOpen(false)
    handleCloseMenu()
  }
  return (
    <CreateColumnProvider id={`insert-${columnToInsert?.positionToInsert}`}>
      <GridModalWrap title={<Trans>Insert New Column</Trans>} handleCloseMenu={handleCloseMenu}>
        <ColumnForm submitLabel={title} onHide={handleClose} onSuccess={handleClose} onCancel={handleClose} />
      </GridModalWrap>
    </CreateColumnProvider>
  )
}
